/**
 * @desc 导出周计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanWeekExportOverviewRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/week/exportPlanOverview',
    data,
  });
}

export function mock(
  data: defs.PlanWeekExportOverviewRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/week/exportPlanOverview',
    data,
  });
}
